import { AxiosBookings, orgId } from "../apiConfig";
import { appendQueryParams } from "../../utilities/urlUtils";

export const fleetFactory = {
  $_getSingleFleet(id) {
    const url = `/fleets/${id}`;
    return AxiosBookings.get(url);
  },
  $_getAssignedFleet(id) {
    const url = `fleets/assigned/driver/${id}/${orgId()}`;
    return AxiosBookings.get(url);
  },
  $_updateFleet(id, payload) {
    const url = `/fleets/${id}`;
    return AxiosBookings.patch(url, payload);
  },
  $_getAllFleets(params) {
    const url = `/fleets/org/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
    $_getAllFleetsForConsolidation(params) {
    const url = `/consolidation/vehicles/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_getAllPublicFleet(params) {
    const url = `/fleets/public${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_addPublicFleet(payload){
    const url = `/fleets/add-public`;
    return AxiosBookings.post(url, payload);
  },
  $_deleteFleet(fleetId) {
    const url = `/fleets/${fleetId}`;
    return AxiosBookings.delete(url);
  },

  $_createFleet(payload) {
    let url = "/fleets";
    return AxiosBookings.post(url, payload);
  },

  $_getAllAssignFleets() {
    const url = "/fleets/assigned";
    return AxiosBookings.get(url);
  },

  $_assignToFleet(shippingId, payload) {
    const url = `/shippings/fleetassign/${shippingId}`;
    return AxiosBookings.patch(url, payload);
  },

  $_unassignFromFleet(payload) {
    const url = `/shippings/fleetremove/${payload.shippingId}`;
    delete payload.shippingId;
    return AxiosBookings.patch(url, payload);
  },

  $_dispatchFleet(fleetId) {
    const url = `/fleets/dispatch/${fleetId}`;
    return AxiosBookings.patch(url);
  },

  $_getAllDispatch() {
    const url = `/dispatch/all/${orgId()}`;
    return AxiosBookings.get(url);
  },

  $_pauseDispatch(fleetId) {
    const url = `/fleets/pause-dispatch/${fleetId}`;
    return AxiosBookings.patch(url);
  },
  $_getLeasedFleet(params){
    const url = `/fleets/public/lease/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_getUserMyFleet(params){
    const url = `/fleets/with-user/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_getUserMyFleetRequest(fleetId){
    const url = `/fleets/public/request/${fleetId}`;
    return AxiosBookings.get(url);
  },
  $_acceptFleetRequest(payload){
    const url = `/fleets/public/process`;
    return AxiosBookings.post(url, payload);
  }
};
